export const Step = {
    WRITING_SPECIFICATIONS: "WRITING_SPECIFICATIONS",
    APPROVAL_SPECIFICATIONS_BY_MANAGER: "APPROVAL_SPECIFICATIONS_BY_MANAGER",
    BUDGET_LEGAL_CHECK: "BUDGET_LEGAL_CHECK",
    APPROVAL_SPECIFICATIONS: "APPROVAL_SPECIFICATIONS",
    APPROVAL_SPECIFICATIONS_BY_BOD: "APPROVAL_SPECIFICATIONS_BY_BOD",
    VALIDATION_ENCODING_E_PROCUREMENT: "VALIDATION_ENCODING_E_PROCUREMENT",
    VALIDATION_OFFER_REQUEST_EMAIL: "VALIDATION_OFFER_REQUEST_EMAIL",
    WRITING_ATTRIBUTION: "WRITING_ATTRIBUTION",
    APPROVAL_ATTRIBUTION: "APPROVAL_ATTRIBUTION",
    APPROVAL_ATTRIBUTION_BY_BOD: "APPROVAL_ATTRIBUTION_BY_BOD",
    VALIDATION_ATTRIBUTION: "VALIDATION_ATTRIBUTION",
    WRITING_ORDER: "WRITING_ORDER",
    VALIDATION_ORDER: "VALIDATION_ORDER",
    UNASSIGNED: "UNASSIGNED",
    END: "END",
};

export const getApprovalDescriptionByStep = {
    WRITING_SPECIFICATIONS: `Voulez-vous soumettre à approbation le <span style="font-weight: bold;">cahier des charges</span> et la <span style="font-weight: bold;">note de lancement</span> ?`,
    APPROVAL_SPECIFICATIONS_BY_MANAGER: `Voulez-vous valider le <span style="font-weight: bold;">cahier des charges</span> et la <span style="font-weight: bold;">note de lancement</span> ?`,
    BUDGET_LEGAL_CHECK: `Voulez-vous valider le <span style="font-weight: bold;">cahier des charges</span> et la <span style="font-weight: bold;">note de lancement</span> ?`,
    APPROVAL_SPECIFICATIONS: `Voulez-vous valider le <span style="font-weight: bold;">cahier des charges</span> et la <span style="font-weight: bold;">note de lancement</span> ?`,
    APPROVAL_SPECIFICATIONS_BY_BOD: `Voulez-vous valider le <span style="font-weight: bold;">cahier des charges</span> et la <span style="font-weight: bold;">note de lancement</span> ?`,
    VALIDATION_ENCODING_E_PROCUREMENT: `Voulez-vous confirmer que l'<span style="font-weight: bold;">encodage</span> du marché public dans <span style="font-weight: bold;">e-Procurement</span> a bien été effectué ?`,
    VALIDATION_OFFER_REQUEST_EMAIL: `Voulez-vous valider l'envoi du <span style="font-weight: bold;">cahier des charges</span> aux soumissionnaires ?`,
    WRITING_ATTRIBUTION: `Voulez-vous soumettre à approbation le <span style="font-weight: bold;">rapport d'attribution</span> ?`,
    APPROVAL_ATTRIBUTION: `Voulez-vous valider le <span style="font-weight: bold;">rapport d'attribution</span> ?`,
    APPROVAL_ATTRIBUTION_BY_BOD: `Voulez-vous valider le <span style="font-weight: bold;">rapport d'attribution</span> ?`,
    VALIDATION_ATTRIBUTION: `Voulez-vous valider la <span style="font-weight: bold;">notification d'attribution</span> ?`,
    WRITING_ORDER: `Voulez-vous soumettre à approbation le <span style="font-weight: bold;">bon de commande</span> ?`,
    VALIDATION_ORDER: `Voulez-vous valider le <span style="font-weight: bold;">bon de commande</span> ?`,
    UNASSIGNED: ``,
    END: ``,
};

export const getColorByStep = {
    WRITING_SPECIFICATIONS: "orange",
    APPROVAL_SPECIFICATIONS_BY_MANAGER: "blue",
    BUDGET_LEGAL_CHECK: "yellow",
    APPROVAL_SPECIFICATIONS: "blue",
    APPROVAL_SPECIFICATIONS_BY_BOD: "blue",
    VALIDATION_ENCODING_E_PROCUREMENT: "blue",
    VALIDATION_OFFER_REQUEST_EMAIL: "blue",
    WRITING_ATTRIBUTION: "orange",
    APPROVAL_ATTRIBUTION: "blue",
    APPROVAL_ATTRIBUTION_BY_BOD: "orange",
    VALIDATION_ATTRIBUTION: "blue",
    WRITING_ORDER: "orange",
    VALIDATION_ORDER: "blue",
    UNASSIGNED: "green",
    END: "green",
};

export const getPositionByStep = {
    WRITING_SPECIFICATIONS: 1,
    APPROVAL_SPECIFICATIONS_BY_MANAGER: 1,
    BUDGET_LEGAL_CHECK: 2,
    APPROVAL_SPECIFICATIONS: 3,
    APPROVAL_SPECIFICATIONS_BY_BOD: 4,
    VALIDATION_ENCODING_E_PROCUREMENT: 5,
    VALIDATION_OFFER_REQUEST_EMAIL: 6,
    WRITING_ATTRIBUTION: 7,
    UNASSIGNED: 7,
    APPROVAL_ATTRIBUTION: 8,
    APPROVAL_ATTRIBUTION_BY_BOD: 9,
    VALIDATION_ATTRIBUTION: 10,
    // WRITING_ORDER: 10,
    // VALIDATION_ORDER: 11,
    END: 12,
};
